import * as angular from 'angular';

import { IRequestService } from '../request.service';

export interface IBackupService {
    getBackups(applicationGuid: string): angular.IPromise<any>;
    createBackup(applicationGuid: string): angular.IPromise<any>;
    restoreBackup(applicationGuid: string, backupName: string): angular.IPromise<boolean>;
    downloadBackup(applicationGuid: string, backupName: string, successCallback: Function);
}

export class BackupService implements IBackupService {

    static serviceId = 'backupService';
    static $inject = ['$q', 'requestService'];

    constructor(
        _$q: angular.IQService,
        private _requestService: IRequestService) {
    }

    private controllerUrl(applicationGuid: string): string {
        return this._requestService.getUrlV1() + 'backup/' + applicationGuid + '/';
    }

    getBackups(applicationGuid: string): angular.IPromise<any> {
        const url = this.controllerUrl(applicationGuid);
        this._requestService.cleanCache(url);
        return this._requestService.get(url);
    }

    createBackup(applicationGuid: string): angular.IPromise<any> {
        const url = this.controllerUrl(applicationGuid);
        return this._requestService.post(url);
    }

    restoreBackup(applicationGuid: string, backupName: string): angular.IPromise<boolean> {
        const url = this.controllerUrl(applicationGuid) + 'restore';
        return this._requestService.post(url, angular.toJson(backupName));
    }

    downloadBackup(applicationGuid: string, backupName: string, successCallback: Function): void {
        const url = this.controllerUrl(applicationGuid) + 'download';
        this._requestService.post(url, angular.toJson(backupName)).then(data => {
            successCallback(data, this._requestService.getApiUrl(), 0);
        });
    }

}